export const faqsCategories = [
  { id: 1, title: "General", icon: "/img/svgs/faq-general.svg" },
  { id: 2, title: "Shopping", icon: "/img/svgs/faq-shopping.svg" },
  { id: 2, title: "Security", icon: "/img/svgs/faq-security.svg" },
];

export const faqsData = [
  {
    id: "1",
    category: "General",
    qna: [
      {
        id: 1,
        question:
          "How Long Will It Take For My Order To Arrive After I Make Payment?",
        answer:
          "<p>Domestic orders normally arrive within 3-7 days of shipping, unless otherwise noted.</p><p>International orders normally arrive within 2-4 weeks of shipping. Please note that these orders need to pass through the customs office in your country before it will be released for final delivery, which can occasionally cause additional delays.</p>",
      },
      {
        id: 2,
        question: "How Can I Change My Shipping Address?",
        answer:
          "<p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p><p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?</p>",
      },
      {
        id: 3,
        question: "How Can I Track My Orders & Payment?",
        answer:
          "<p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p><p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?</p>",
      },
    ],
  },
  {
    id: "1",
    category: "Shopping",
    qna: [
      {
        id: 1,
        question: "Why Must I Make Payment Immediately At Checkout?",
        answer:
          "<p>Domestic orders normally arrive within 3-7 days of shipping, unless otherwise noted.</p><p>International orders normally arrive within 2-4 weeks of shipping. Please note that these orders need to pass through the customs office in your country before it will be released for final delivery, which can occasionally cause additional delays.</p>",
      },
      {
        id: 2,
        question: "What Happens if There's Been A Delivery Mishap To My Order?",
        answer:
          "<p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p><p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?</p>",
      },
      {
        id: 3,
        question: "How Can I Track My Orders & Payment?",
        answer:
          "<p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p><p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?</p>",
      },
    ],
  },
  {
    id: "1",
    category: "Security",
    qna: [
      {
        id: 1,
        question: "How is my Checkout secure?",
        answer:
          "<p>Domestic orders normally arrive within 3-7 days of shipping, unless otherwise noted.</p><p>International orders normally arrive within 2-4 weeks of shipping. Please note that these orders need to pass through the customs office in your country before it will be released for final delivery, which can occasionally cause additional delays.</p>",
      },
      {
        id: 2,
        question: "What Happens if I forgot my password?",
        answer:
          "<p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p><p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?</p>",
      },
      {
        id: 3,
        question: "How Can I change my email address?",
        answer:
          "<p>Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem.</p><p>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur?</p>",
      },
    ],
  },
];
